import React, { Component } from "react";
import { connect } from "react-redux";
import store from "../../store";
class PackageTourList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoader: false,
            showDet: {},
        };
    }

    redirectToSrp = (val) => {
        const urlParams = new URLSearchParams(window.location.search);
        const jDate = urlParams.get("jDate");
        const url = "/search?mode=oneway" +
        "&fromCity=" +
        val.FromCityID +
        "|" +
        val.FromCity +
        "&toCity=" +
        val.ToCityID +
        "|" +
        val.ToCity +
        "&departDate=" +
        jDate +
        "&stationInFromCity=&stationInToCity=&singleLady=0";
       console.log("url",url);
       window.location.href = url;
    }

    openOtherDet = (e, id, param) => {
        e.stopPropagation();
        let showDet = {};
        showDet[id] = param;
        this.setState({ showDet });

        if (this.state.showDet[id] === param) {
            this.setState({ showDet: {} });
          } else this.setState({ showDet });
      };

    showBottomContent = (val) => {
     return(
        <div
        className="srch-card-row"
        style={{
          justifyContent: "space-between",
          padding:0
        }}
      >
        <div className="srch">
            <div 
                onClick={(event) => this.openOtherDet(event, val.PackageId, 1)}
                className={`primarybutton flex-vc ${this.state.showDet[val.PackageId] === 1 ? "active" : ""}`} 
            >
                <span className="lspacerite">Details</span>
                <span 
                className={
                    this.state.showDet[val.PackageId] === 1
                    ? "arrowplain top sc_card"
                    : "arrowplain bottom"}
                ></span>
            </div>
        </div>
        <div className="srch">
           <div 
             onClick={(event) => this.openOtherDet(event, val.PackageId, 2)}
             className={`primarybutton flex-vc ${this.state.showDet[val.PackageId] === 2 ? "active" : ""}`}>
                <span className="lspacerite">Itinerary</span>
                <span
                  className={
                    this.state.showDet[val.PackageId] === 2
                    ? "arrowplain top sc_card"
                    : "arrowplain bottom"}
                ></span>
            </div>
        </div>
        <div className="srch">
          <div 
            onClick={(event) => this.openOtherDet(event, val.PackageId, 3)}
            className={`primarybutton flex-vc ${this.state.showDet[val.PackageId] === 3 ? "active" : ""}`}>
              <span className="lspacerite">Route</span>
              <span
                 className={
                    this.state.showDet[val.PackageId] === 3
                    ? "arrowplain top sc_card"
                    : "arrowplain bottom"}
              ></span>
          </div>
        </div>
        <div className="srch">
           <div 
             onClick={(event) => this.openOtherDet(event, val.PackageId, 4)}
             className={`primarybutton flex-vc ${this.state.showDet[val.PackageId] === 4 ? "active" : ""}`}>
              <span className="lspacerite">Note</span>
              <span
                 className={
                    this.state.showDet[val.PackageId] === 4
                    ? "arrowplain top sc_card"
                    : "arrowplain bottom"}
              ></span>
          </div>
        </div>
        <div className="srch">
            <div 
              onClick={(event) => this.openOtherDet(event, val.PackageId, 5)}
              className={`primarybutton flex-vc ${this.state.showDet[val.PackageId] === 5 ? "active" : ""}`}>
                <span className="lspacerite">Terms & Conditions</span>
                <span
                   className={
                    this.state.showDet[val.PackageId] === 5
                    ? "arrowplain top sc_card"
                    : "arrowplain bottom"}
                ></span>
            </div>
        </div>
        <div>
        <div className="selectbutton" 
           onClick = {()=>this.redirectToSrp(val)}
           style={{
              display:'flex',
              alignItems:'center',
              borderRadius:'4px',
              height:'37px',
              width:'107px',
              justifyContent:'center',
              fontWeight:600,
              fontSize:'0.75em',
              borderWidth:'1px',
              borderStyle:'solid',
              borderColor:'var(--ksrtcThColor2)',
              borderImage:'initial',
              background:'var(--ksrtcThColor2)',
              color:'#FFF'
           }}
           >Book Now</div>
        </div>
      </div>
     )   
    };

    showBottomDetails = (val) =>{
        if (this.state.showDet?.[val.PackageId]) {
            switch (this.state.showDet[val.PackageId]) {
              case 1:
                return (
                    <div className="seatchart" style={{ paddingTop: 12, fontSize: '0.875em' }}>
                       <img style={{width:'100%'}} src = {`${window.awsImagePath}${val.Website.DetailsImg}`} alt ={val.Website.DetailsImg} />
                    </div>
                  );
              case 2:
                return (
                    <div className="seatchart" style={{ paddingTop: 12, fontSize: '0.875em' }}>
                      <img style={{width:'100%'}} src = {`${window.awsImagePath}${val.Website.ItenraryImg}`} alt ={val.Website.ItenraryImg} />
                    </div>
                  );
              case 3:
                return (
                    <div className="seatchart" style={{ paddingTop: 12, fontSize: '0.875em' }}>
                      <img style={{width:'100%'}} src = {`${window.awsImagePath}${val.Website.RouteImg}`} alt ={val.Website.RouteImg} />
                    </div>
                  );
              case 4:
                return (
                  <div className="seatchart" style={{ paddingTop: 12, fontSize: '0.875em' }}>
                    <img style={{width:'100%'}} src = {`${window.awsImagePath}${val.Website.NoteImg}`} alt ={val.Website.NoteImg} /> 
                  </div>
                );
      
              case 5:
                return (
                  <div className="seatchart" style={{ paddingTop: 12, fontSize: '0.875em' }}>
                    <img style={{width:'100%'}} src = {`${window.awsImagePath}${val.Website.TandcImg}`} alt ={val.Website.TandcImg} />
                  </div>
                );
      
              default:
                return (
                  <div className="seatchart" style={{ paddingTop: 12 }}>
                    No data found
                  </div>
                );
            }
          }
    }

    renderPackage = () =>{
      console.log("data",this.props.data);
      const {data} = this.props
      if(data.length > 0){
       return data.map((el,index) =>{
            if(el.IsActive){
                return(
                    <div key = {index} className="package--card">
                        <div className="package--details">
                            <div className="top--sec">{el.TourPackageName}</div>
                            <div className="middle--section">
                                <div className="content">
                                    <div>Days of Operation</div>
                                    <div>{el.Dop}</div>
                                </div>
                                <div className="content">
                                    <div>Departure Time</div>
                                    <div>{el.TourCategoryId == 1 ? "-" : el.DepartureTime}</div>
                                </div>
                                <div className="content">
                                    <div>Accomodation</div>
                                    <div>{el.AccomodationType}</div>
                                </div>
                                <div className="content">
                                    <div>Class of Service</div>
                                    <div>{el.ServiceType}</div>
                                </div>
                                <div className="content">
                                    <div>Fare</div>
                                    <div>{this.props.search.currency}{el.Fare}</div>
                                </div>
                            </div>
                            <div className="bottom--section">
                            {this.showBottomContent(el)}
                            </div>
                            {this.showBottomDetails(el)}
                        </div>
                    </div>
                )
            }
        })
      }
    }

    render(){
        return(
            <div className="package_tour_booking_wrapper">
                {this.renderPackage()}              
            </div>
        )
    }
} 

const mapStateToProps = function (store) {
    return store;
};

export default connect(mapStateToProps)(PackageTourList);